﻿const uuid4 = () => {
    const ho = (n, p) => n.toString(16).padStart(p, 0); /// Return the hexadecimal text representation of number `n`, padded with zeroes to be of length `p`
    const data = crypto.getRandomValues(new Uint8Array(16)); /// Fill the buffer with random data
    data[6] = (data[6] & 0xf) | 0x40; /// Patch the 6th byte to reflect a version 4 UUID
    data[8] = (data[8] & 0x3f) | 0x80; /// Patch the 8th byte to reflect a variant 1 UUID (version 4 UUIDs are)
    const view = new DataView(data.buffer); /// Create a view backed by a 16-byte buffer
    return `${ho(view.getUint32(0), 8)}-${ho(view.getUint16(4), 4)}-${ho(view.getUint16(6), 4)}-${ho(view.getUint16(8), 4)}-${ho(view.getUint32(10), 8)}${ho(view.getUint16(14), 4)}`; /// Compile the canonical textual form from the array data
};

if (document.readyState === "complete") { doEverything(); } else {
    document.addEventListener("DOMContentLoaded", function () {
        doEverything();
    });
}

function doEverything() {
    var testpage = "http://localhost:5287/res/testpane.html"; //this is used for debugging purposes
    //don't report stats on localhost
    if (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "") {
        //unless we are on our debugger page
        if (location.href != testpage)
            return;
    }

    var loadTimeMS = window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart;
    var uid = uuid4();
    var deviceType = dType();
    var ref = (document.referrer ?? "").replace(/https?:\/\//,"");
    ref = ref.replace(/\?.*$/,"");
    ref = ref.replace(/#.*$/,"");
    var data = { deviceType: deviceType, uid: uid, referrer: ref, pathname: window.location.pathname, loadTimeMS: loadTimeMS, isVisible:true };
    var msg = JSON.stringify(data);
    var msg2send = { method: "post", body: msg, headers: { 'Content-Type': 'application/json' }, keepalive: true };

    var ep = "https://stats.isotropic.us/api/postData";
    if (location.href == testpage) //for testing
        ep = "http://localhost:5287/api/postData";

    var upd = () => fetch(ep, msg2send);
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState == 'hidden') {
            data.isVisible = false;
            msg = JSON.stringify(data);
            msg2send = { method: "post", body: msg, headers: { 'Content-Type': 'application/json' }, keepalive: true };
            upd();
        } else if (document.visibilityState == 'visible') {
            data.isVisible = true;
            msg = JSON.stringify(data);
            msg2send = { method: "post", body: msg, headers: { 'Content-Type': 'application/json' }, keepalive: true };
            upd();
        }
    });
    setInterval(upd, 60 * 1000);
    upd();
}


function dType(): "tablet" | "mobile" | "desktop" {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
    }
    else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return "mobile";
    }
    return "desktop";
};